export const iconFontAwesomeCommunicationComment = (
	<i className="fa-solid fa-comment"></i>
);
